import { createSelector, createSlice } from '@reduxjs/toolkit';
import { PdpState } from '../store';

export const { actions, reducer } = createSlice({
    name: 'tenant',
    initialState: {
        id: 'missing',
        enableAiStudio: false
    },
    reducers: {}
});

export const selectTenantId = createSelector(
    (state: PdpState) => state.tenant.id,
    id => id);

export const isAiStudioEnabledByTenant = createSelector(
    (state: PdpState) => state.tenant.enableAiStudio,
    aiStudio => aiStudio);